import { defineMessages } from 'react-intl';

export const messages: {
	description: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	header: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	description: {
		id: 'navigation.global-more-menu.error.description',
		defaultMessage: 'Refresh the page and try again',
		description: 'Description when an unknown error occurs',
	},
	header: {
		id: 'navigation.global-more-menu.error.header',
		defaultMessage: 'We couldn’t load more sidebar options',
		description: 'Header when an unknown error occurs',
	},
});
